var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.56 90.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1a1a1a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_020---Good-Sleep",
    "data-name": "020---Good-Sleep"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "m3.62,37.79c-4.8,12.53-4.8,26.4,0,38.93.2.53.06,1.12-.35,1.51-5.48,5.05-3.68,12.05,2.52,12.05,2.79-.11,5.43-1.31,7.35-3.35.39-.4.98-.54,1.51-.35,15.4,4.93,45.84,4.93,61.23,0,.53-.19,1.12-.06,1.51.35,3.1,3.19,8.42,4.69,11.48,1.85s1.63-7.64-1.6-10.55c-.39-.4-.53-.98-.36-1.51,4.84-12.61,4.82-26.58-.08-39.18-.17-.51,0-1.08.44-1.4,3.21-3.01,4.52-7.82,1.6-10.55-2.92-2.73-8.47-1.3-11.48,1.85-.4.38-.98.52-1.51.35-2.53-.78-5.12-1.4-7.73-1.85-.83-.15-1.63.4-1.78,1.24s.4,1.63,1.24,1.78c2.49.43,4.94,1.02,7.35,1.76,1.6.51,3.35.08,4.52-1.12,3.01-3.01,7.96-3.39,7.96,0-.14,1.72-.97,3.31-2.29,4.41-1.38,1.18-1.85,3.11-1.16,4.79,4.54,11.84,4.54,24.94,0,36.78-.71,1.72-.28,3.7,1.08,4.96,1.32,1.08,2.16,2.65,2.32,4.35,0,3.5-4.93,3.13-7.97,0-1.17-1.21-2.92-1.65-4.52-1.13-14.75,4.73-44.62,4.73-59.4,0-1.6-.52-3.35-.08-4.52,1.13-3.01,3.01-7.97,3.44-7.97,0,.14-1.73.97-3.32,2.31-4.43,1.36-1.26,1.79-3.23,1.07-4.94-4.49-11.79-4.49-24.82,0-36.61.71-1.72.28-3.7-1.08-4.96-1.32-1.1-2.14-2.68-2.29-4.38,0-3.54,5-3.01,7.97,0,1.17,1.21,2.92,1.65,4.52,1.13,9.55-3.1,23.97-4.02,34.22-3.6.83,0,1.51-.67,1.51-1.51s-.67-1.51-1.51-1.51c-10.55-.3-25.18.44-35.18,3.63-.53.19-1.12.06-1.51-.35-3-3.13-8.33-4.61-11.38-1.78-2.4,2.21-2.46,6.87,1.6,10.55.44.42.58,1.06.36,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "m15.07,79.69c.74.37,1.64.09,2.02-.65,5.44-10.62,5.44-32.95,0-43.58-.39-.71-1.28-.99-2.01-.62-.73.37-1.02,1.25-.68,1.99,4.99,9.73,5.02,31.04,0,40.83-.37.74-.08,1.64.66,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-1",
    d: "m46.71,39.18c0-.83-.67-1.51-1.51-1.51h-2.4l3.47-3.45c.43-.43.57-1.08.33-1.65-.23-.57-.79-.93-1.4-.93h-6.03c-.83,0-1.51.67-1.51,1.51s.67,1.51,1.51,1.51h2.4l-3.47,3.45c-.43.43-.57,1.08-.33,1.65.23.57.79.93,1.4.93h6.03c.83,0,1.51-.67,1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-1",
    d: "m64.79,31.64c0-.83-.67-1.51-1.51-1.51h-6.92l7.99-7.97c.43-.43.57-1.08.33-1.65-.23-.57-.79-.93-1.4-.93h-10.55c-.83,0-1.51.67-1.51,1.51s.67,1.51,1.51,1.51h6.92l-7.99,7.97c-.43.43-.57,1.08-.33,1.65.23.57.79.93,1.4.93h10.55c.83,0,1.51-.67,1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-1",
    d: "m78.35,16.57c.83,0,1.51-.67,1.51-1.51s-.67-1.51-1.51-1.51h-9.93l11-10.98c.43-.43.57-1.08.33-1.65C79.52.36,78.96,0,78.35,0h-13.56c-.83,0-1.51.67-1.51,1.51s.67,1.51,1.51,1.51h9.93l-11,10.98c-.43.43-.57,1.08-.33,1.65.23.57.79.93,1.4.93h13.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "cls-1",
    d: "m37.67,51.23v1.51c0,.83.67,1.51,1.51,1.51s1.51-.67,1.51-1.51v-1.51c0-.83-.67-1.51-1.51-1.51s-1.51.67-1.51,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    className: "cls-1",
    d: "m58.76,51.23v1.51c0,.83.67,1.51,1.51,1.51s1.51-.67,1.51-1.51v-1.51c0-.83-.67-1.51-1.51-1.51s-1.51.67-1.51,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    className: "cls-1",
    d: "m49.72,66.3c4.16,0,7.53-3.37,7.53-7.53,0-.83-.67-1.51-1.51-1.51s-1.51.67-1.51,1.51c0,2.5-2.02,4.52-4.52,4.52s-4.52-2.02-4.52-4.52c0-.83-.67-1.51-1.51-1.51s-1.51.67-1.51,1.51c0,4.16,3.37,7.53,7.53,7.53Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillow);
export default __webpack_public_path__ + "static/media/pillow.bfd447193ec6ffdc96e202881bdb101f.svg";
export { ForwardRef as ReactComponent };